import { StringEnum } from "../../../typescript/StringEnum";

// TODO: Typescript 2.4 enum string types
export const BfxFindOrdersFilterFieldName = StringEnum({
  // most of these are on V_ORDER_DATA

  ORDER_ID: "orderRef",
  // Maps to DEAL_ID on V_TRADE_DATA
  TRADE_ID: "dealRef",

  STRATEGY_ID: "strategyRef",

  // Maps to CL_ORD_ID on V_TRADE_DATA
  EXTERNAL_REF: "clOrdID",
  // Booking UTI is a Flexism that maps to BOOKING_IDS on V_TRADE_DATA

  // TYPEO ON Server
  BOOKING_UTI: "bookindIds",

  NETTING_ID: "nettingId",
  FWD_NETTING_ID: "fwdNettingId",

  // BENCHMARK ORDER TYPE
  BM_ORDER_TYPE: "bmOrderType",

  // Client
  CLIENT_ID: "clientCode",
  CLIENT_NAME: "clientName",
  ACCOUNT_ID: "accountCode",
  ACCOUNT_NAME: "accountName",
  CLIENT_TRADER: "clientTraderName",
  BRANCH: "clientBranchCode",
  SALES_GROUP: "salesGroupId",
  CHANNEL: "channelCd",

  CCY: "ccy",
  INSTRUMENT: "instrument",
  //??
  CCY_PAIR_GROUP: "ccyPairGroup",

  TYPE: "requestedOrderType",
  ALGO_STRATEGY_TYPE: "algoStrategyName",

  ENTRY_DATE: "entryDts",
  ENTRY_USER: "entryUserId",
  MODIFY_DATE: "modifyDts",
  MODIFY_USER: "modifyUser",
  CANCEL_DATE: "cancelDts",
  CANCEL_USER: "cancelUserId",
  EXPIRED_DATE: "expiryDts",

  ORDER_AMT: "orderQty",
  ORDER_AMT_USD: "usdEquivQty",
  REMAINING_AMT: "leavesQty",
  REMAINING_AMT_USD: "usdEquivLeavesQty",

  REQUEST_RT: "requestRt",

  // note from spec Should cover all states ungrouped.
  ORDER_STATE: "orderState",

  //product mapping
  PRODUCT: "product",

  //fix code mapping
  FIXCODE: "fixingSourceCd",

  // Benchmarks
  BM_FIXCODE: "bmFixingSourceCd",
  FIXING_TIME: "fixingTime",
  FIXING_DATE: "fixingDate",
  PRICING_ERROR: "pricingError",
  PRICING_EXPIRED: "pricingExpired",

  BM_SPAWNED: "showSpawnedOrders",
  BM_FORWARD_FIRST: "bmForwardFirst",
  SEARCH_IN_TZ: "timezoneCd",

  OBO_CLIENT: "oboClient",
  OBO_ACCOUNT: "oboAccount",

  REQ_QUOTE_ID: "reqQuoteId",
});
